import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss";

const StatsSection = () => {
    return (
        <div className="container">
            <section className={styles.statsSection}>
                {/* Left Blobs */}
                <div className={`${styles.blob} ${styles.blobLarge} ${styles.blobLeft}`}></div>
                <div className={`${styles.blob} ${styles.blobSmall} ${styles.blobLeft}`}></div>

                {/* Stats Items */}
                <div className={styles.statItem}>
                    <h3>Year of Experience</h3>
                    <p>6+</p>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.statItem}>
                    <h3>Happy Clients</h3>
                    <p>100+</p>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.statItem}>
                    <h3>Projects Completed</h3>
                    <p>150+</p>
                </div>

                {/* Right Blobs */}
                <div className={`${styles.blob} ${styles.blobLarge} ${styles.blobRight}`}></div>
                <div className={`${styles.blob} ${styles.blobSmall} ${styles.blobRight}`}></div>
            </section>

        </div>
    );
};

export default StatsSection;
